import React from 'react';
import _ from 'lodash';

import './MainWorkoutView.css';
import MyButton from '../components/MyButton';
import {colors} from '../styles/colors';
import {CircularProgress} from 'material-ui';

function ComingUp() {
	return <p className='withLine comingUp'>coming up</p>;
}

const activeCtaStyles = {
	backgroundColor: '#0adfed',
	color: 'white',
};

const idleCtaStyles = {
	backgroundColor: colors.white,
	color: '#029EE9',
};

function CTA({text, onPress, loading, progress, isWorkoutActive}) {
	return (
		<div className='workout-view-cta-container'>
			<MyButton
				style={{
					boxShadow: 'none',
					height: 50,
					...(isWorkoutActive ? activeCtaStyles : idleCtaStyles),
					width: '100%',
					fontSize: 16,
				}}
				onPressButton={onPress}
				title={text}
				color='secondary'
				size='large'
				variant='raised'
				loading={loading}
				progress={progress}
			/>
		</div>
	);
}

function CurrentExcerciseInfo({amount, unit, name}) {
	return (
		<div className='workoutInfo' style={{height: 120}}>
			<div className='workoutRepInfo roundedDetailWrapper active'>
				<span className='workoutRepInfo-amount'>{amount}</span>
				<span className='workoutRepInfo-unit'>{unit}</span>
			</div>
			<div className='workoutInfo-workoutName'>
				<p>{name}</p>
			</div>
		</div>
	);
}

function NextExcerciseInfo({nextExcercise, t}) {
	const {
		excercise_info: {name, reps, duration, video_image},
	} = nextExcercise;
	const isPause = name === 'Pause';
	const unit =
		name === 'Pause' || duration ? t('workout:secs') : t('workout:reps');
	const amount = reps || duration;
	return (
		<React.Fragment>
			<ComingUp />
			<div className='nextWorkoutWrapper'>
				{!isPause && (
					<div className='roundedDetailWrapper nextWorkoutImage'>
						<img
							className='roundedDetailWrapper'
							src={video_image}
						/>
					</div>
				)}

				<div className='workoutInfo'>
					<div className='workoutRepInfo roundedDetailWrapper nextWorkoutInfo'>
						<span className='amount'>{isPause ? 30 : amount}</span>
						<span className='unit'>{unit}</span>
					</div>
					<div className='nextExcerciseName'>
						<p>{name}</p>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
}

export default function MainWorkoutView({
	ctaText,
	handleCtaPress,
	excerciseProgress,
	currentExcercise,
	nextExcercise,
	t,
	isWaitingForStart,
	onVideoLoadFinish,
	onVideoLoadStart,
	isLoadingVideo,
}) {
	if (!currentExcercise) return null;
	const {
		excercise_info: {video, name, reps, duration},
	} = currentExcercise;
	const isPause = name === 'Pause';
	return (
		<React.Fragment>
			<div
				className={`workout-view-video-wrapper ${
					!isPause && isWaitingForStart && !isLoadingVideo
						? 'overlay'
						: ''
				}`}
			>
				{isLoadingVideo && !isPause && (
					<div className='workout-view-video-loader'>
						<CircularProgress style={{color: '#fff'}} />
					</div>
				)}
				{!isPause && (
					<video
						src={video}
						autoPlay
						loop
						playsInline
						className='workout-view-video'
						onLoadStart={onVideoLoadStart}
						onLoadedData={onVideoLoadFinish}
					/>
				)}
				{isPause && (
					<div
						style={{
							display: 'flex',
							height: '100%',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<img
							// style={{height: '100%'}}
							src={require('./pause.png')}
						/>
					</div>
				)}
			</div>

			<div className='workout-view-info-wrapper'>
				<CTA
					text={ctaText}
					onPress={handleCtaPress}
					progress={excerciseProgress}
					isWorkoutActive={!isWaitingForStart && reps}
				/>
				<CurrentExcerciseInfo
					amount={name === 'Pause' ? 30 : reps || duration}
					unit={
						name === 'Pause' || duration
							? t('workout:secs')
							: t('workout:reps')
					}
					name={name}
				/>
				{nextExcercise && (
					<NextExcerciseInfo nextExcercise={nextExcercise} t={t} />
				)}
			</div>
		</React.Fragment>
	);
}



// WEBPACK FOOTER //
// ./src/workout/MainWorkoutView.js